var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"text-center wrap"},[_c('v-col',{attrs:{"cols":"12"}},[_c('HeadMetadata',{attrs:{"title":_vm.pageTitle}}),_vm._v(" If you're not redirected automatically, please "),_c('a',{staticClass:"px-1",attrs:{"href":_vm.loginUrl}},[_vm._v("click here")]),_vm._v(" to login. ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }